export default "__VITE_ASSET__eb60af0d__"